import { PermissionKeys } from "app/types/permissions";
export type MenuItemType = {
  uri: string;
  label: string;
  type: "nav-item" | "collapsible";
  keyName: PermissionKeys;
  children?: MenuItemType[];
};

const menus: MenuItemType[] = [
  {
    uri: "/dashboards/subscriptions",
    label: "pages.subscription.title",
    type: "nav-item",
    keyName: PermissionKeys.SUBSCRIPTION_VIEW,
  },
  {
    uri: "/dashboards/clients",
    label: "common.clients",
    type: "nav-item",
    keyName: PermissionKeys.CLIENTS_VIEW,
  },
  {
    uri: "/dashboards/menus/catalogs",
    label: "pages.meal.title",
    type: "nav-item",
    keyName: PermissionKeys.MEALS_VIEW,
  },
  {
    uri: "/dashboards/custom-meals",
    label: "Custom Meals",
    type: "collapsible",
    keyName: PermissionKeys.CUSTOM_MEALS_VIEW,
    children: [
      {
        uri: "/dashboards/custom-meals",
        label: "Custom Meals",
        type: "nav-item",
        keyName: PermissionKeys.CUSTOM_MEALS_VIEW,
      },
      {
        uri: "/dashboards/sub-recipes",
        label: "SubRecipe",
        type: "nav-item",
        keyName: PermissionKeys.CUSTOM_MEALS_VIEW,
      },
      {
        uri: "/dashboards/ingredients",
        label: "Ingredients",
        type: "nav-item",
        keyName: PermissionKeys.CUSTOM_MEALS_VIEW,
      },
      {
        uri: "/dashboards/meal-types",
        label: "Meal Types",
        type: "nav-item",
        keyName: PermissionKeys.CUSTOM_MEALS_VIEW,
      },
      {
        uri: "/dashboards/ingredients-classifications",
        label: "Ingredients Classifications",
        type: "nav-item",
        keyName: PermissionKeys.CUSTOM_MEALS_VIEW,
      },
    ],
  },
  {
    uri: "/dashboards/productions",
    label: "pages.production.title",
    type: "nav-item",

    keyName: PermissionKeys.PRODUCTION_VIEW,
  },
  {
    uri: "/dashboards/delivery-orders",
    label: "common.deliveryOrder",
    type: "nav-item",
    keyName: PermissionKeys.DELIVERY_VIEW,
  },
  {
    uri: "/dashboards/manage-packages",
    label: "Manage Packages",
    type: "collapsible",
    keyName: PermissionKeys.PACKAGES_VIEW,
    children: [
      {
        uri: "/dashboards/packages/groups",
        label: "Groups",
        type: "nav-item",
        keyName: PermissionKeys.GROUPS_VIEW,
      },
      {
        uri: "/dashboards/packages",
        label: "Packages",
        type: "nav-item",

        keyName: PermissionKeys.PACKAGES_VIEW,
      },
      {
        uri: "/dashboards/price-plans-management",
        label: "Price Plans",
        type: "nav-item",
        keyName: PermissionKeys.PRICEPLAN_VIEW,
      },
      {
        uri: "/dashboards/group-themes",
        label: "Group Themes",
        type: "nav-item",
        keyName: PermissionKeys.GROUPS_VIEW,
      },
    ],
  },
  {
    uri: "/dashboards/promotions",
    label: "common.promotions",
    type: "collapsible",
    keyName: PermissionKeys.PROMOTION_VIEW,
    children: [
      {
        uri: "/dashboards/promotions",
        label: "common.promotions",
        type: "nav-item",
        keyName: PermissionKeys.PROMOTION_VIEW,
      },
      {
        uri: "/dashboards/group-promotions",
        label: "common.groupPromotion",
        type: "nav-item",
        keyName: PermissionKeys.PROMOTION_VIEW,
      },
      {
        uri: "/dashboards/addpopup",
        label: "Advertisements",
        type: "nav-item",
        keyName: PermissionKeys.PROMOTION_VIEW,
      },
    ],
  },
  {
    uri: "/dashboards/orders",
    label: "Numou Now",
    type: "collapsible",
    keyName: PermissionKeys.ORDERS_VIEW,
    children: [
      {
        uri: "/dashboards/orders",
        label: "common.orders",
        type: "nav-item",
        keyName: PermissionKeys.ORDERS_VIEW,
      },
      {
        uri: "/dashboards/wallets",
        label: "Wallets",
        type: "nav-item",
        keyName: PermissionKeys.WALLET_VIEW,
      },
      {
        uri: "/dashboards/products",
        label: "common.products",
        type: "nav-item",
        keyName: PermissionKeys.PRODUCTS_VIEW,
      },
      {
        uri: "/dashboards/stocks",
        label: "common.stocks",
        type: "nav-item",
        keyName: PermissionKeys.STOCKS_VIEW,
      },
    ],
  },
  {
    uri: "/dashboards/zone-configurations",
    label: "common.configuration",
    type: "nav-item",
    keyName: PermissionKeys.CONFIGURATION_VIEW,
  },
  {
    uri: "/dashboards/distribution-tasks",
    label: "Delivery Logistics",
    type: "collapsible",
    children: [
      {
        uri: "/dashboards/distribution-tasks",
        label: "Delivery Tasks",
        type: "nav-item",

        keyName: PermissionKeys.CONFIGURATION_VIEW,
      },
      {
        uri: "/dashboards/manage-drivers",
        label: "Manage Drivers",
        type: "nav-item",
        keyName: PermissionKeys.CONFIGURATION_VIEW,
      },
      {
        uri: "/dashboards/distribution-deliveries",
        label: "Call Center",
        type: "nav-item",
        keyName: PermissionKeys.CONFIGURATION_VIEW,
      },
      {
        uri: "/dashboards/distribution-delivery-planning",
        label: "Delivery Planning",
        type: "nav-item",
        keyName: PermissionKeys.CONFIGURATION_VIEW,
      },
    ],
    keyName: PermissionKeys.CONFIGURATION_VIEW,
  },
  {
    uri: "/dashboards/customerSupport",
    label: "common.customerSupport",
    type: "collapsible",
    children: [
      {
        uri: "/dashboards/customerSupport",
        label: "common.customerSupport",
        type: "nav-item",
        keyName: PermissionKeys.CLIENTS_VIEW,
      },
      {
        uri: "/dashboards/saudi-analytics",
        label: "Saudi Analytics",
        type: "nav-item",
        keyName: PermissionKeys.ANALYTICS_VIEW,
      },
      {
        uri: "/dashboards/analytics",
        label: "common.lightfieldsAnalytics",
        type: "nav-item",
        keyName: PermissionKeys.ANALYTICS_REVENUE_VIEW,
      },
      {
        uri: "/dashboards/visits",
        label: "common.visits",
        type: "nav-item",
        keyName: PermissionKeys.CLIENTS_VIEW,
      },
      {
        uri: "/dashboards/consultations",
        label: "pages.consultation.consultations",
        type: "nav-item",
        keyName: PermissionKeys.CLIENTS_VIEW,
      },
    ],
    keyName: PermissionKeys.CLIENTS_VIEW,
  },
  {
    uri: "/dashboards/subscription-transfer",
    label: "Subcsription Transfer",
    type: "nav-item",
    keyName: PermissionKeys.SUBSCRIPTION_MANAGE,
  },
  {
    uri: "/dashboards/allergy-sections",
    label: "Allergy Sections",
    type: "nav-item",
    keyName: PermissionKeys.ALLERGIES_VIEW,
  },
  {
    uri: "/dashboards/notification-campaign",
    label: "Notification Campaign",
    type: "nav-item",
    keyName: PermissionKeys.NOTIFICATION_CAMPAIGN_VIEW,
  },
  {
    uri: "/dashboards/permission-management",
    label: "Permission Management",
    type: "collapsible",
    keyName: PermissionKeys.STAFF_MANAGE,
    children: [
      {
        uri: "/dashboards/staff-list",
        label: "Staffs",
        type: "nav-item",
        keyName: PermissionKeys.STAFF_MANAGE,
      },
      {
        uri: "/dashboards/privileges",
        label: "Privileges",
        type: "nav-item",
        keyName: PermissionKeys.STAFF_MANAGE,
      },
      {
        uri: "/dashboards/permission-list",
        label: "Permissions",
        type: "nav-item",
        keyName: PermissionKeys.STAFF_MANAGE,
      },
      {
        uri: "/dashboards/app-configurations",
        label: "App Config",
        type: "nav-item",
        keyName: PermissionKeys.STAFF_MANAGE,
      },
    ],
  },
];

export default menus;
